import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const StudentPortalContext = createContext(null);
const STORAGE_KEY = "doxa_student_class_context";

export function StudentPortalProvider({ children }) {
  const [context, setContext] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedClassId, setSelectedClassIdState] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/student/portal/context");
      setContext(data);
      const activeIds = new Set((data.active_classes || []).map((row) => row.class_group_id));
      const stored = localStorage.getItem(STORAGE_KEY);
      const next = stored && activeIds.has(stored) ? stored : data.default_class_group_id;
      setSelectedClassIdState(next || null);
      if (next) localStorage.setItem(STORAGE_KEY, next);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const setSelectedClassId = (id) => {
    const activeIds = new Set((context?.active_classes || []).map((row) => row.class_group_id));
    if (!id || !activeIds.has(id)) return;
    setSelectedClassIdState(id);
    localStorage.setItem(STORAGE_KEY, id);
  };

  const selectedClass = useMemo(
    () => (context?.active_classes || []).find((row) => row.class_group_id === selectedClassId) || null,
    [context, selectedClassId]
  );

  return (
    <StudentPortalContext.Provider value={{
      context,
      loading,
      selectedClassId,
      selectedClass,
      activeClasses: context?.active_classes || [],
      historyClasses: context?.history_classes || [],
      setSelectedClassId,
      refreshContext: load,
    }}>
      {children}
    </StudentPortalContext.Provider>
  );
}

export function useStudentPortalContext() {
  const value = useContext(StudentPortalContext);
  if (!value) throw new Error("useStudentPortalContext deve ser usado dentro de StudentPortalProvider");
  return value;
}
